@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.drivertargets

import com.narbase.letsgo.web.dto.drivergroups.DriverGroupDto
import com.narbase.letsgo.web.dto.driverprofilegroup.DriverProfileGroupDto

class ExtendedTargetDto(
    val target: TargetDto,
    val driverProfileGroup: DriverProfileGroupDto?,
    val driverGroups: Array<DriverGroupDto>
)